// navbar-fixed
function setNavHeight() {
  const nav = document.querySelector('.navbar');

  if (nav.classList.contains('fixed-top')) {
    const root = document.querySelector(':root');
    root.style.setProperty('--navHeight', `${nav.offsetHeight}px`);
  }
}

function closeDropdownMobileNav() {
  const anchorLinks = document.querySelectorAll('.navbar-nav a.nav-link');
  const navbarToggle = document.querySelector('.navbar-toggler');
  const navbarNav = document.querySelector('#navbarNav');

  anchorLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {

      if (navbarToggle && navbarNav) {
        navbarToggle.classList.add('collapsed');
        navbarNav.classList.remove('show');
      }
    });
  });
}

window.addEventListener('resize', setNavHeight);
window.addEventListener('DOMContentLoaded', function() {
  setNavHeight();
  closeDropdownMobileNav();
});
